import CustomerName from './CustomerName'
import Language from './Language'

export default class Person {
  public name: CustomerName = new CustomerName()
  public dateOfBirth: string | null = ''
  public gender: string | null = ''
  public languages: Language[] = []
}
